import { render, staticRenderFns } from "./Profites.vue?vue&type=template&id=5927f499&scoped=true"
import script from "./Profites.vue?vue&type=script&lang=js"
export * from "./Profites.vue?vue&type=script&lang=js"
import style0 from "./Profites.vue?vue&type=style&index=0&id=5927f499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927f499",
  null
  
)

export default component.exports